import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import SaveIcon from "@material-ui/icons/Save";
import CloseIcon from "@material-ui/icons/Close";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";

class PtsConfirmDialogue extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      title: props.title,
      text: props.text,
      confirmCallback: props.confirmCallback,
      notConfirmCallback: props.notConfirmCallback,
      pageId: this.props.pageId,
    };
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleConfirmYes = () => {
    if (this.state.confirmCallback) {
      this.state.confirmCallback();
    } else if (this.props.confirmCallback) {
      this.props.confirmCallback();
    }
    this.setState({ open: false });
  };
  handleConfirmNo = () => {
    this.handleClose();
  };

  showDeleteMessage() {
    if (this.state.pageId === "Asset") {
      return (
        <span style={{ textAlign: "center" }}>
          <p className="m-0" style={{ fontSize: "16px" }}>
            This will delete asset
            <br></br>
            <span
              style={{
                color: " #37517e",
                fontWeight: "bold",
                fontSize: "16px",
              }}
            >
              “{this.props.text}”.
            </span>
          </p>
        </span>
      );
    } else if (this.state.pageId === "UnitOfMeasurement") {
      return (
        <span style={{ textAlign: "center" }}>
          <p className="m-0" style={{ fontSize: "16px" }}>
            You are about to permanently delete measure
            <br></br>
            <span
              style={{
                color: " #37517e",
                fontWeight: "bold",
                fontSize: "16px",
              }}
            >
              “{this.props.text}”.
            </span>
          </p>
        </span>
      );
    } else if (this.state.pageId === "returnableAsset") {
      return (
        <span style={{ textAlign: "center" }}>
          <p className="m-0" style={{ fontSize: "16px" }}>
            This asset will be removed from Returnable Plan
          </p>
        </span>
      );
    } else {
      return (
        <span style={{ textAlign: "center" }}>
          <p className="m-0" style={{ fontSize: "16px" }}>
            You are about to permanently delete the{" "}
            <span style={{ textTransform: "lowercase" }}>
              {this.state.title}
            </span>
            <br></br>
            <span
              style={{
                color: " #37517e",
                fontWeight: "bold",
                fontSize: "16px",
              }}
            >
              “{this.props.text}”.
            </span>
          </p>
        </span>
      );
    }
  }

  render() {
    return (
      <Dialog
        open={this.state.open}
        onClose={this.handleClose.bind(this)}
        // onHide={this.close}
        style={{ padding: "1em" }}
      >
        <DialogContent>{this.showDeleteMessage()}</DialogContent>
        <DialogActions
          style={{
            // marginTop: "1em",
            padding: "1em",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <Button
            variant="contained"
            type="button"
            size="large"
            style={{
              background: "#37517e",
              color: "#fff",
              marginRight: "1rem",
              padding: "2px 10px",
              textTransform: "capitalize",
            }}
            startIcon={<SaveIcon />}
            onClick={this.handleConfirmYes.bind(this)}
          >
            Confirm
          </Button>
          <Button
            variant="contained"
            size="large"
            type="button"
            style={{
              background: "#717373",
              color: "#fff",
              marginRight: "1rem",
              padding: "2px 10px",
              textTransform: "capitalize",
            }}
            startIcon={<CloseIcon />}
            onClick={this.handleConfirmNo.bind(this)}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default PtsConfirmDialogue;
